import ko from "knockout";

export function AppViewModel() {
  this.isOffline = ko.observable(false);
  this.offlineMessage = ko.observable(
    "You are currently offline. Please reconnect to the internet.",
  );

  // Initialize connection status
  this.checkConnection();

  // Event listeners for online/offline events
  window.addEventListener("online", this.checkConnection.bind(this));
  window.addEventListener("offline", this.checkConnection.bind(this));
}

// Function to check internet connection
AppViewModel.prototype.checkConnection = function () {
  this.isOffline(!navigator.onLine);
};
